import _styled from "styled-components";
import * as React from 'react';
import { Toast as FlowBiteToast } from 'flowbite-react';
import { Button } from '../../';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var InteractiveToast = function InteractiveToast(_ref) {
  var message = _ref.message,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title;
  return /*#__PURE__*/_jsxs(ToastWrapper, {
    children: [/*#__PURE__*/_jsxs(_StyledDiv, {
      children: [/*#__PURE__*/_jsx("span", {
        className: "text-sm font-semibold text-gray-900 dark:text-white",
        children: title
      }), /*#__PURE__*/_jsx(FlowBiteToast.Toggle, {})]
    }), /*#__PURE__*/_jsx("div", {
      className: "text-sm font-normal",
      children: message
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex gap-2",
      children: [/*#__PURE__*/_jsx(Button, {
        title: "Continua senza CV",
        buttonSize: "small",
        variant: "primary"
      }), /*#__PURE__*/_jsx(Button, {
        title: "Not now",
        buttonSize: "small",
        variant: "secondary-outline"
      })]
    })]
  });
};
export default InteractiveToast;

var ToastWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "toastinteractive__ToastWrapper",
  componentId: "sc-s2n5mn-0"
})(["", ""], {
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "0.75rem",
  "padding": "0.5rem"
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "toastinteractive___StyledDiv",
  componentId: "sc-s2n5mn-1"
})({
  "display": "flex",
  "justifyContent": "space-between"
});